@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources/"

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.analytics_back_a11y: StringResource by lazy {
      StringResource("string:analytics_back_a11y", "analytics_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 35),
      ))
    }

@delegate:ResourceContentHash(1_862_448_058)
internal val Res.string.analytics_delta_down: StringResource by lazy {
      StringResource("string:analytics_delta_down", "analytics_delta_down", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 54, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46, 40),
      ))
    }

@delegate:ResourceContentHash(-1_037_623_061)
internal val Res.string.analytics_delta_up: StringResource by lazy {
      StringResource("string:analytics_delta_up", "analytics_delta_up", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 95, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 91, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87, 38),
      ))
    }

@delegate:ResourceContentHash(-1_403_293_910)
internal val Res.string.analytics_empty_desc: StringResource by lazy {
      StringResource("string:analytics_empty_desc", "analytics_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 134, 224),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 130, 168),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126, 140),
      ))
    }

@delegate:ResourceContentHash(-803_858_915)
internal val Res.string.analytics_empty_title: StringResource by lazy {
      StringResource("string:analytics_empty_title", "analytics_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 359, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 299, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 267, 49),
      ))
    }

@delegate:ResourceContentHash(370_438_710)
internal val Res.string.analytics_period_month: StringResource by lazy {
      StringResource("string:analytics_period_month", "analytics_period_month", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 433, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 373, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 317, 38),
      ))
    }

@delegate:ResourceContentHash(683_016_272)
internal val Res.string.analytics_period_week: StringResource by lazy {
      StringResource("string:analytics_period_week", "analytics_period_week", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 472, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 412, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 356, 37),
      ))
    }

@delegate:ResourceContentHash(-1_153_934_531)
internal val Res.string.analytics_stat_shares: StringResource by lazy {
      StringResource("string:analytics_stat_shares", "analytics_stat_shares", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 514, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 454, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 394, 37),
      ))
    }

@delegate:ResourceContentHash(-498_511_344)
internal val Res.string.analytics_subtitle: StringResource by lazy {
      StringResource("string:analytics_subtitle", "analytics_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 588, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 496, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 432, 58),
      ))
    }

@delegate:ResourceContentHash(1_490_718_388)
internal val Res.string.analytics_title: StringResource by lazy {
      StringResource("string:analytics_title", "analytics_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 659, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 563, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 491, 35),
      ))
    }

@delegate:ResourceContentHash(826_481_124)
internal val Res.string.analytics_trends_section: StringResource by lazy {
      StringResource("string:analytics_trends_section", "analytics_trends_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 695, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 603, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 527, 56),
      ))
    }

@delegate:ResourceContentHash(177_031_699)
internal val Res.string.dash_add_listing: StringResource by lazy {
      StringResource("string:dash_add_listing", "dash_add_listing", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 756, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 668, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 584, 40),
      ))
    }

@delegate:ResourceContentHash(761_462_452)
internal val Res.string.dash_attrs_button: StringResource by lazy {
      StringResource("string:dash_attrs_button", "dash_attrs_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 813, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 725, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 625, 41),
      ))
    }

@delegate:ResourceContentHash(-293_494_677)
internal val Res.string.dash_attrs_hint: StringResource by lazy {
      StringResource("string:dash_attrs_hint", "dash_attrs_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 875, 339),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 779, 215),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 667, 167),
      ))
    }

@delegate:ResourceContentHash(772_191_497)
internal val Res.string.dash_attrs_save: StringResource by lazy {
      StringResource("string:dash_attrs_save", "dash_attrs_save", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1215, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 995, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 835, 31),
      ))
    }

@delegate:ResourceContentHash(-602_099_348)
internal val Res.string.dash_attrs_title: StringResource by lazy {
      StringResource("string:dash_attrs_title", "dash_attrs_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1255, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1035, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 867, 52),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.dash_back_a11y: StringResource by lazy {
      StringResource("string:dash_back_a11y", "dash_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1320, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1092, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 920, 30),
      ))
    }

@delegate:ResourceContentHash(1_371_152_013)
internal val Res.string.dash_channel: StringResource by lazy {
      StringResource("string:dash_channel", "dash_channel", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1359, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1123, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 951, 44),
      ))
    }

@delegate:ResourceContentHash(-535_239_523)
internal val Res.string.dash_deals_button: StringResource by lazy {
      StringResource("string:dash_deals_button", "dash_deals_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1416, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1172, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 996, 33),
      ))
    }

@delegate:ResourceContentHash(-501_534_150)
internal val Res.string.dash_deals_create: StringResource by lazy {
      StringResource("string:dash_deals_create", "dash_deals_create", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1466, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1206, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1030, 41),
      ))
    }

@delegate:ResourceContentHash(1_777_534_184)
internal val Res.string.dash_deals_days_chip: StringResource by lazy {
      StringResource("string:dash_deals_days_chip", "dash_deals_days_chip", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1524, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1256, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1072, 40),
      ))
    }

@delegate:ResourceContentHash(-1_951_596_339)
internal val Res.string.dash_deals_delete_a11y: StringResource by lazy {
      StringResource("string:dash_deals_delete_a11y", "dash_deals_delete_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1569, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1301, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1113, 46),
      ))
    }

@delegate:ResourceContentHash(270_369_605)
internal val Res.string.dash_deals_ended: StringResource by lazy {
      StringResource("string:dash_deals_ended", "dash_deals_ended", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1624, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1360, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1160, 32),
      ))
    }

@delegate:ResourceContentHash(-1_902_394_991)
internal val Res.string.dash_deals_ends_days: StringResource by lazy {
      StringResource("string:dash_deals_ends_days", "dash_deals_ends_days", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1681, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1397, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1193, 52),
      ))
    }

@delegate:ResourceContentHash(25_826_740)
internal val Res.string.dash_deals_headline_label: StringResource by lazy {
      StringResource("string:dash_deals_headline_label", "dash_deals_headline_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1742, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1462, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1246, 85),
      ))
    }

@delegate:ResourceContentHash(-256_323_490)
internal val Res.string.dash_deals_title: StringResource by lazy {
      StringResource("string:dash_deals_title", "dash_deals_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1852, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1552, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1332, 48),
      ))
    }

@delegate:ResourceContentHash(2_092_095_673)
internal val Res.string.dash_delete_button: StringResource by lazy {
      StringResource("string:dash_delete_button", "dash_delete_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1929, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1605, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1381, 46),
      ))
    }

@delegate:ResourceContentHash(-1_955_998_596)
internal val Res.string.dash_delete_cancel: StringResource by lazy {
      StringResource("string:dash_delete_cancel", "dash_delete_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1976, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1656, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1428, 34),
      ))
    }

@delegate:ResourceContentHash(2_049_085_911)
internal val Res.string.dash_delete_confirm: StringResource by lazy {
      StringResource("string:dash_delete_confirm", "dash_delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2011, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1695, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1463, 35),
      ))
    }

@delegate:ResourceContentHash(-1_580_641_497)
internal val Res.string.dash_delete_failed: StringResource by lazy {
      StringResource("string:dash_delete_failed", "dash_delete_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2047, 126),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1735, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1499, 90),
      ))
    }

@delegate:ResourceContentHash(874_506_410)
internal val Res.string.dash_delete_message: StringResource by lazy {
      StringResource("string:dash_delete_message", "dash_delete_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2174, 255),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1834, 179),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1590, 151),
      ))
    }

@delegate:ResourceContentHash(-1_904_424_135)
internal val Res.string.dash_delete_title: StringResource by lazy {
      StringResource("string:dash_delete_title", "dash_delete_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2430, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2014, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1742, 53),
      ))
    }

@delegate:ResourceContentHash(-745_285_406)
internal val Res.string.dash_edit_listing_button: StringResource by lazy {
      StringResource("string:dash_edit_listing_button", "dash_edit_listing_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2496, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2072, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1796, 48),
      ))
    }

@delegate:ResourceContentHash(-683_765_778)
internal val Res.string.dash_empty_desc: StringResource by lazy {
      StringResource("string:dash_empty_desc", "dash_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2557, 207),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2129, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1845, 115),
      ))
    }

@delegate:ResourceContentHash(-1_347_525_694)
internal val Res.string.dash_empty_title: StringResource by lazy {
      StringResource("string:dash_empty_title", "dash_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2765, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2269, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1961, 44),
      ))
    }

@delegate:ResourceContentHash(-1_413_891_160)
internal val Res.string.dash_error: StringResource by lazy {
      StringResource("string:dash_error", "dash_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2838, 146),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2338, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2006, 94),
      ))
    }

@delegate:ResourceContentHash(-193_062_415)
internal val Res.string.dash_manage_orders: StringResource by lazy {
      StringResource("string:dash_manage_orders", "dash_manage_orders", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2985, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2457, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2101, 34),
      ))
    }

@delegate:ResourceContentHash(-942_089_932)
internal val Res.string.dash_manage_products: StringResource by lazy {
      StringResource("string:dash_manage_products", "dash_manage_products", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3036, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2496, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2136, 48),
      ))
    }

@delegate:ResourceContentHash(-398_400_170)
internal val Res.string.dash_manage_reviews: StringResource by lazy {
      StringResource("string:dash_manage_reviews", "dash_manage_reviews", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3101, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2553, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2185, 47),
      ))
    }

@delegate:ResourceContentHash(2_055_696_793)
internal val Res.string.dash_plan_city_30d: StringResource by lazy {
      StringResource("string:dash_plan_city_30d", "dash_plan_city_30d", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3161, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2601, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2233, 70),
      ))
    }

@delegate:ResourceContentHash(-1_729_653_998)
internal val Res.string.dash_plan_city_7d: StringResource by lazy {
      StringResource("string:dash_plan_city_7d", "dash_plan_city_7d", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3244, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2680, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2304, 65),
      ))
    }

@delegate:ResourceContentHash(1_292_819_157)
internal val Res.string.dash_plan_top_30d: StringResource by lazy {
      StringResource("string:dash_plan_top_30d", "dash_plan_top_30d", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3322, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2758, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2370, 57),
      ))
    }

@delegate:ResourceContentHash(1_932_586_532)
internal val Res.string.dash_privacy_button: StringResource by lazy {
      StringResource("string:dash_privacy_button", "dash_privacy_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3396, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2832, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2428, 39),
      ))
    }

@delegate:ResourceContentHash(626_204_890)
internal val Res.string.dash_privacy_hidden_desc: StringResource by lazy {
      StringResource("string:dash_privacy_hidden_desc", "dash_privacy_hidden_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3452, 204),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2884, 172),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2468, 140),
      ))
    }

@delegate:ResourceContentHash(1_236_714_315)
internal val Res.string.dash_privacy_hidden_title: StringResource by lazy {
      StringResource("string:dash_privacy_hidden_title", "dash_privacy_hidden_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3657, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3057, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2609, 69),
      ))
    }

@delegate:ResourceContentHash(-1_853_680_352)
internal val Res.string.dash_privacy_hide_address_desc: StringResource by lazy {
      StringResource("string:dash_privacy_hide_address_desc", "dash_privacy_hide_address_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3755, 250),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3131, 186),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2679, 154),
      ))
    }

@delegate:ResourceContentHash(1_338_060_161)
internal val Res.string.dash_privacy_hide_address_title: StringResource by lazy {
      StringResource("string:dash_privacy_hide_address_title", "dash_privacy_hide_address_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4006, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3318, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2834, 63),
      ))
    }

@delegate:ResourceContentHash(772_191_497)
internal val Res.string.dash_privacy_save: StringResource by lazy {
      StringResource("string:dash_privacy_save", "dash_privacy_save", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4102, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3394, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2898, 33),
      ))
    }

@delegate:ResourceContentHash(1_394_153_102)
internal val Res.string.dash_privacy_title: StringResource by lazy {
      StringResource("string:dash_privacy_title", "dash_privacy_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4144, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3436, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2932, 54),
      ))
    }

@delegate:ResourceContentHash(-968_438_678)
internal val Res.string.dash_promote_button: StringResource by lazy {
      StringResource("string:dash_promote_button", "dash_promote_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4215, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3507, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2987, 47),
      ))
    }

@delegate:ResourceContentHash(-392_923_488)
internal val Res.string.dash_promote_failed: StringResource by lazy {
      StringResource("string:dash_promote_failed", "dash_promote_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4271, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3563, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3035, 83),
      ))
    }

@delegate:ResourceContentHash(988_160_476)
internal val Res.string.dash_promote_needs_metro: StringResource by lazy {
      StringResource("string:dash_promote_needs_metro", "dash_promote_needs_metro", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4407, 152),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3667, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3119, 104),
      ))
    }

@delegate:ResourceContentHash(2_080_397_206)
internal val Res.string.dash_promote_subtitle: StringResource by lazy {
      StringResource("string:dash_promote_subtitle", "dash_promote_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4560, 257),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3784, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3224, 157),
      ))
    }

@delegate:ResourceContentHash(777_709_657)
internal val Res.string.dash_promote_title: StringResource by lazy {
      StringResource("string:dash_promote_title", "dash_promote_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4818, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3986, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3382, 54),
      ))
    }

@delegate:ResourceContentHash(-519_013_771)
internal val Res.string.dash_qr_a11y: StringResource by lazy {
      StringResource("string:dash_qr_a11y", "dash_qr_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4885, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4053, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3437, 60),
      ))
    }

@delegate:ResourceContentHash(-1_652_273_626)
internal val Res.string.dash_qr_button: StringResource by lazy {
      StringResource("string:dash_qr_button", "dash_qr_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4962, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4122, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3498, 34),
      ))
    }

@delegate:ResourceContentHash(179_301_687)
internal val Res.string.dash_qr_hint: StringResource by lazy {
      StringResource("string:dash_qr_hint", "dash_qr_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4997, 292),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4157, 240),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3533, 208),
      ))
    }

@delegate:ResourceContentHash(-279_236_376)
internal val Res.string.dash_qr_share: StringResource by lazy {
      StringResource("string:dash_qr_share", "dash_qr_share", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5290, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4398, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3742, 37),
      ))
    }

@delegate:ResourceContentHash(-1_760_784_228)
internal val Res.string.dash_qr_title: StringResource by lazy {
      StringResource("string:dash_qr_title", "dash_qr_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5360, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4444, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3780, 49),
      ))
    }

@delegate:ResourceContentHash(1_659_655_342)
internal val Res.string.dash_rating_count: StringResource by lazy {
      StringResource("string:dash_rating_count", "dash_rating_count", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5414, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4494, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3830, 57),
      ))
    }

@delegate:ResourceContentHash(-2_029_959_231)
internal val Res.string.dash_retry: StringResource by lazy {
      StringResource("string:dash_retry", "dash_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5472, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4548, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3888, 30),
      ))
    }

@delegate:ResourceContentHash(1_756_058_021)
internal val Res.string.dash_section_listings: StringResource by lazy {
      StringResource("string:dash_section_listings", "dash_section_listings", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5519, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4583, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3919, 49),
      ))
    }

@delegate:ResourceContentHash(-1_175_268_904)
internal val Res.string.dash_stat_leads: StringResource by lazy {
      StringResource("string:dash_stat_leads", "dash_stat_leads", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5585, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4637, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3969, 31),
      ))
    }

@delegate:ResourceContentHash(-82_843_715)
internal val Res.string.dash_stat_listings: StringResource by lazy {
      StringResource("string:dash_stat_listings", "dash_stat_listings", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5629, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4673, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4001, 38),
      ))
    }

@delegate:ResourceContentHash(258_934_938)
internal val Res.string.dash_stat_pending: StringResource by lazy {
      StringResource("string:dash_stat_pending", "dash_stat_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5680, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4716, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4040, 69),
      ))
    }

@delegate:ResourceContentHash(1_692_458_962)
internal val Res.string.dash_stat_rating: StringResource by lazy {
      StringResource("string:dash_stat_rating", "dash_stat_rating", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5766, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4802, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4110, 40),
      ))
    }

@delegate:ResourceContentHash(-1_842_427_983)
internal val Res.string.dash_stat_reviews: StringResource by lazy {
      StringResource("string:dash_stat_reviews", "dash_stat_reviews", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5827, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4843, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4151, 37),
      ))
    }

@delegate:ResourceContentHash(-640_137_549)
internal val Res.string.dash_stat_views: StringResource by lazy {
      StringResource("string:dash_stat_views", "dash_stat_views", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5869, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4877, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4189, 31),
      ))
    }

@delegate:ResourceContentHash(-475_422_787)
internal val Res.string.dash_status_approved: StringResource by lazy {
      StringResource("string:dash_status_approved", "dash_status_approved", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5917, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4909, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4221, 36),
      ))
    }

@delegate:ResourceContentHash(1_396_517_131)
internal val Res.string.dash_status_pending: StringResource by lazy {
      StringResource("string:dash_status_pending", "dash_status_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5958, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4950, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4258, 39),
      ))
    }

@delegate:ResourceContentHash(-234_709_502)
internal val Res.string.dash_status_rejected: StringResource by lazy {
      StringResource("string:dash_status_rejected", "dash_status_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6010, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4994, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4298, 40),
      ))
    }

@delegate:ResourceContentHash(484_290_824)
internal val Res.string.dash_status_suspended: StringResource by lazy {
      StringResource("string:dash_status_suspended", "dash_status_suspended", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6055, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5035, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4339, 41),
      ))
    }

@delegate:ResourceContentHash(-1_712_191_759)
internal val Res.string.dash_title: StringResource by lazy {
      StringResource("string:dash_title", "dash_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6097, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5077, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4381, 42),
      ))
    }

@delegate:ResourceContentHash(-1_582_522_237)
internal val Res.string.dash_tour_analytics_body: StringResource by lazy {
      StringResource("string:dash_tour_analytics_body", "dash_tour_analytics_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6160, 196),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5116, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4424, 124),
      ))
    }

@delegate:ResourceContentHash(539_454_649)
internal val Res.string.dash_tour_analytics_title: StringResource by lazy {
      StringResource("string:dash_tour_analytics_title", "dash_tour_analytics_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6357, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5249, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4549, 65),
      ))
    }

@delegate:ResourceContentHash(456_345_244)
internal val Res.string.dash_tour_channel_body: StringResource by lazy {
      StringResource("string:dash_tour_channel_body", "dash_tour_channel_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6463, 202),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5323, 154),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4615, 150),
      ))
    }

@delegate:ResourceContentHash(897_267_965)
internal val Res.string.dash_tour_channel_title: StringResource by lazy {
      StringResource("string:dash_tour_channel_title", "dash_tour_channel_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6666, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5478, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4766, 63),
      ))
    }

@delegate:ResourceContentHash(1_051_723_581)
internal val Res.string.dash_tour_deals_body: StringResource by lazy {
      StringResource("string:dash_tour_deals_body", "dash_tour_deals_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6766, 188),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5542, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4830, 104),
      ))
    }

@delegate:ResourceContentHash(859_788_341)
internal val Res.string.dash_tour_deals_title: StringResource by lazy {
      StringResource("string:dash_tour_deals_title", "dash_tour_deals_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6955, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5683, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4935, 45),
      ))
    }

@delegate:ResourceContentHash(1_400_206_660)
internal val Res.string.dash_tour_done: StringResource by lazy {
      StringResource("string:dash_tour_done", "dash_tour_done", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7037, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5737, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4981, 30),
      ))
    }

@delegate:ResourceContentHash(-174_894_513)
internal val Res.string.dash_tour_edit_body: StringResource by lazy {
      StringResource("string:dash_tour_edit_body", "dash_tour_edit_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7076, 359),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5772, 251),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5012, 203),
      ))
    }

@delegate:ResourceContentHash(509_077_903)
internal val Res.string.dash_tour_edit_title: StringResource by lazy {
      StringResource("string:dash_tour_edit_title", "dash_tour_edit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7436, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6024, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5216, 52),
      ))
    }

@delegate:ResourceContentHash(1_058_028_854)
internal val Res.string.dash_tour_help_a11y: StringResource by lazy {
      StringResource("string:dash_tour_help_a11y", "dash_tour_help_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7521, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6081, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5269, 59),
      ))
    }

@delegate:ResourceContentHash(291_023_027)
internal val Res.string.dash_tour_next: StringResource by lazy {
      StringResource("string:dash_tour_next", "dash_tour_next", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7593, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6153, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5329, 30),
      ))
    }

@delegate:ResourceContentHash(1_821_333_663)
internal val Res.string.dash_tour_products_body: StringResource by lazy {
      StringResource("string:dash_tour_products_body", "dash_tour_products_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7628, 243),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6188, 167),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5360, 151),
      ))
    }

@delegate:ResourceContentHash(767_579_911)
internal val Res.string.dash_tour_products_title: StringResource by lazy {
      StringResource("string:dash_tour_products_title", "dash_tour_products_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7872, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6356, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5512, 56),
      ))
    }

@delegate:ResourceContentHash(512_839_012)
internal val Res.string.dash_tour_qr_body: StringResource by lazy {
      StringResource("string:dash_tour_qr_body", "dash_tour_qr_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7965, 245),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6425, 185),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5569, 153),
      ))
    }

@delegate:ResourceContentHash(1_189_315_439)
internal val Res.string.dash_tour_qr_title: StringResource by lazy {
      StringResource("string:dash_tour_qr_title", "dash_tour_qr_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8211, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6611, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5723, 50),
      ))
    }

@delegate:ResourceContentHash(1_520_148_457)
internal val Res.string.dash_tour_reviews_body: StringResource by lazy {
      StringResource("string:dash_tour_reviews_body", "dash_tour_reviews_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8286, 230),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6670, 170),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5774, 154),
      ))
    }

@delegate:ResourceContentHash(-995_523_654)
internal val Res.string.dash_tour_reviews_title: StringResource by lazy {
      StringResource("string:dash_tour_reviews_title", "dash_tour_reviews_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8517, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6841, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5929, 55),
      ))
    }

@delegate:ResourceContentHash(1_350_352_312)
internal val Res.string.dash_tour_skip: StringResource by lazy {
      StringResource("string:dash_tour_skip", "dash_tour_skip", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8593, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6897, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5985, 30),
      ))
    }

@delegate:ResourceContentHash(-568_392_909)
internal val Res.string.dash_view_analytics: StringResource by lazy {
      StringResource("string:dash_view_analytics", "dash_view_analytics", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8632, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6928, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6016, 47),
      ))
    }

@delegate:ResourceContentHash(-314_308_773)
internal val Res.string.dash_view_listing: StringResource by lazy {
      StringResource("string:dash_view_listing", "dash_view_listing", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8688, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6984, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6064, 33),
      ))
    }

@delegate:ResourceContentHash(1_457_191_742)
internal val Res.string.dash_welcome: StringResource by lazy {
      StringResource("string:dash_welcome", "dash_welcome", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8730, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7018, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6098, 84),
      ))
    }

@delegate:ResourceContentHash(319_791_594)
internal val Res.string.edit_add_photo: StringResource by lazy {
      StringResource("string:edit_add_photo", "edit_add_photo", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8831, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7111, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6183, 34),
      ))
    }

@delegate:ResourceContentHash(-316_656_186)
internal val Res.string.edit_address_line_label: StringResource by lazy {
      StringResource("string:edit_address_line_label", "edit_address_line_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8882, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7158, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6218, 51),
      ))
    }

@delegate:ResourceContentHash(-1_726_339_949)
internal val Res.string.edit_category_label: StringResource by lazy {
      StringResource("string:edit_category_label", "edit_category_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8946, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7202, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6270, 39),
      ))
    }

@delegate:ResourceContentHash(-602_661_611)
internal val Res.string.edit_change_cover: StringResource by lazy {
      StringResource("string:edit_change_cover", "edit_change_cover", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9002, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7246, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6310, 41),
      ))
    }

@delegate:ResourceContentHash(86_982_420)
internal val Res.string.edit_change_logo: StringResource by lazy {
      StringResource("string:edit_change_logo", "edit_change_logo", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9048, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7300, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6352, 32),
      ))
    }

@delegate:ResourceContentHash(828_458_534)
internal val Res.string.edit_city_label: StringResource by lazy {
      StringResource("string:edit_city_label", "edit_city_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9085, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7333, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6385, 31),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("analytics_back_a11y", Res.string.analytics_back_a11y)
  map.put("analytics_delta_down", Res.string.analytics_delta_down)
  map.put("analytics_delta_up", Res.string.analytics_delta_up)
  map.put("analytics_empty_desc", Res.string.analytics_empty_desc)
  map.put("analytics_empty_title", Res.string.analytics_empty_title)
  map.put("analytics_period_month", Res.string.analytics_period_month)
  map.put("analytics_period_week", Res.string.analytics_period_week)
  map.put("analytics_stat_shares", Res.string.analytics_stat_shares)
  map.put("analytics_subtitle", Res.string.analytics_subtitle)
  map.put("analytics_title", Res.string.analytics_title)
  map.put("analytics_trends_section", Res.string.analytics_trends_section)
  map.put("dash_add_listing", Res.string.dash_add_listing)
  map.put("dash_attrs_button", Res.string.dash_attrs_button)
  map.put("dash_attrs_hint", Res.string.dash_attrs_hint)
  map.put("dash_attrs_save", Res.string.dash_attrs_save)
  map.put("dash_attrs_title", Res.string.dash_attrs_title)
  map.put("dash_back_a11y", Res.string.dash_back_a11y)
  map.put("dash_channel", Res.string.dash_channel)
  map.put("dash_deals_button", Res.string.dash_deals_button)
  map.put("dash_deals_create", Res.string.dash_deals_create)
  map.put("dash_deals_days_chip", Res.string.dash_deals_days_chip)
  map.put("dash_deals_delete_a11y", Res.string.dash_deals_delete_a11y)
  map.put("dash_deals_ended", Res.string.dash_deals_ended)
  map.put("dash_deals_ends_days", Res.string.dash_deals_ends_days)
  map.put("dash_deals_headline_label", Res.string.dash_deals_headline_label)
  map.put("dash_deals_title", Res.string.dash_deals_title)
  map.put("dash_delete_button", Res.string.dash_delete_button)
  map.put("dash_delete_cancel", Res.string.dash_delete_cancel)
  map.put("dash_delete_confirm", Res.string.dash_delete_confirm)
  map.put("dash_delete_failed", Res.string.dash_delete_failed)
  map.put("dash_delete_message", Res.string.dash_delete_message)
  map.put("dash_delete_title", Res.string.dash_delete_title)
  map.put("dash_edit_listing_button", Res.string.dash_edit_listing_button)
  map.put("dash_empty_desc", Res.string.dash_empty_desc)
  map.put("dash_empty_title", Res.string.dash_empty_title)
  map.put("dash_error", Res.string.dash_error)
  map.put("dash_manage_orders", Res.string.dash_manage_orders)
  map.put("dash_manage_products", Res.string.dash_manage_products)
  map.put("dash_manage_reviews", Res.string.dash_manage_reviews)
  map.put("dash_plan_city_30d", Res.string.dash_plan_city_30d)
  map.put("dash_plan_city_7d", Res.string.dash_plan_city_7d)
  map.put("dash_plan_top_30d", Res.string.dash_plan_top_30d)
  map.put("dash_privacy_button", Res.string.dash_privacy_button)
  map.put("dash_privacy_hidden_desc", Res.string.dash_privacy_hidden_desc)
  map.put("dash_privacy_hidden_title", Res.string.dash_privacy_hidden_title)
  map.put("dash_privacy_hide_address_desc", Res.string.dash_privacy_hide_address_desc)
  map.put("dash_privacy_hide_address_title", Res.string.dash_privacy_hide_address_title)
  map.put("dash_privacy_save", Res.string.dash_privacy_save)
  map.put("dash_privacy_title", Res.string.dash_privacy_title)
  map.put("dash_promote_button", Res.string.dash_promote_button)
  map.put("dash_promote_failed", Res.string.dash_promote_failed)
  map.put("dash_promote_needs_metro", Res.string.dash_promote_needs_metro)
  map.put("dash_promote_subtitle", Res.string.dash_promote_subtitle)
  map.put("dash_promote_title", Res.string.dash_promote_title)
  map.put("dash_qr_a11y", Res.string.dash_qr_a11y)
  map.put("dash_qr_button", Res.string.dash_qr_button)
  map.put("dash_qr_hint", Res.string.dash_qr_hint)
  map.put("dash_qr_share", Res.string.dash_qr_share)
  map.put("dash_qr_title", Res.string.dash_qr_title)
  map.put("dash_rating_count", Res.string.dash_rating_count)
  map.put("dash_retry", Res.string.dash_retry)
  map.put("dash_section_listings", Res.string.dash_section_listings)
  map.put("dash_stat_leads", Res.string.dash_stat_leads)
  map.put("dash_stat_listings", Res.string.dash_stat_listings)
  map.put("dash_stat_pending", Res.string.dash_stat_pending)
  map.put("dash_stat_rating", Res.string.dash_stat_rating)
  map.put("dash_stat_reviews", Res.string.dash_stat_reviews)
  map.put("dash_stat_views", Res.string.dash_stat_views)
  map.put("dash_status_approved", Res.string.dash_status_approved)
  map.put("dash_status_pending", Res.string.dash_status_pending)
  map.put("dash_status_rejected", Res.string.dash_status_rejected)
  map.put("dash_status_suspended", Res.string.dash_status_suspended)
  map.put("dash_title", Res.string.dash_title)
  map.put("dash_tour_analytics_body", Res.string.dash_tour_analytics_body)
  map.put("dash_tour_analytics_title", Res.string.dash_tour_analytics_title)
  map.put("dash_tour_channel_body", Res.string.dash_tour_channel_body)
  map.put("dash_tour_channel_title", Res.string.dash_tour_channel_title)
  map.put("dash_tour_deals_body", Res.string.dash_tour_deals_body)
  map.put("dash_tour_deals_title", Res.string.dash_tour_deals_title)
  map.put("dash_tour_done", Res.string.dash_tour_done)
  map.put("dash_tour_edit_body", Res.string.dash_tour_edit_body)
  map.put("dash_tour_edit_title", Res.string.dash_tour_edit_title)
  map.put("dash_tour_help_a11y", Res.string.dash_tour_help_a11y)
  map.put("dash_tour_next", Res.string.dash_tour_next)
  map.put("dash_tour_products_body", Res.string.dash_tour_products_body)
  map.put("dash_tour_products_title", Res.string.dash_tour_products_title)
  map.put("dash_tour_qr_body", Res.string.dash_tour_qr_body)
  map.put("dash_tour_qr_title", Res.string.dash_tour_qr_title)
  map.put("dash_tour_reviews_body", Res.string.dash_tour_reviews_body)
  map.put("dash_tour_reviews_title", Res.string.dash_tour_reviews_title)
  map.put("dash_tour_skip", Res.string.dash_tour_skip)
  map.put("dash_view_analytics", Res.string.dash_view_analytics)
  map.put("dash_view_listing", Res.string.dash_view_listing)
  map.put("dash_welcome", Res.string.dash_welcome)
  map.put("edit_add_photo", Res.string.edit_add_photo)
  map.put("edit_address_line_label", Res.string.edit_address_line_label)
  map.put("edit_category_label", Res.string.edit_category_label)
  map.put("edit_change_cover", Res.string.edit_change_cover)
  map.put("edit_change_logo", Res.string.edit_change_logo)
  map.put("edit_city_label", Res.string.edit_city_label)
}
